import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RedirectService } from './services/redirect.service'

//SSO RedHat (Keycloak)
import { KeycloakService, KeycloakAngularModule } from 'keycloak-angular';
import { SSOInitializer } from './utils/rhsso/sso-app-init';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    KeycloakAngularModule
  ],
  providers: [RedirectService,
    {
      provide: APP_INITIALIZER,
      useFactory: SSOInitializer,
      multi: true,
      deps: [KeycloakService],
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
